import type { FC } from 'react'

import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Talk to an expert`,
  description: `Learn how our support expertise can help you reduce risk.`,
}

const button = {
  text: `Talk to an expert`,
  url: `/demo/`,
}

const TalkToAnExpert: FC = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper>
      <StyledSection variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h3" variant="h2">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pLarge">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
          <Cta color="primary" variant="filled" size="large" href={getAbsoluteUrl(button.url, pageConfig)}>
            {button.text}
          </Cta>
        </Section.Copy>
      </StyledSection>
    </Wrapper>
  )
}

export default TalkToAnExpert

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 0;
  }
`

const Cta = styled(Button)`
  margin: 24px 0 0;
`
